import React from 'react';
import {StyleSheet, View} from 'react-native';
import {wp} from '../../utils';

const LandscapePage = ({leftContent, rightContent}) => {
  return (
    <View style={styles.container}>
      <View style={styles.leftPanel}>{leftContent}</View>
      <View style={styles.rightPanel}>{rightContent}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flex: 1,
  },
  leftPanel: {
    width: wp(30),
    backgroundColor: 'white',
  },
  rightPanel: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
  },
});

export default LandscapePage;
